// en, de, fr, pt
export default {
	en: {
		TrackingLocation: "Vị trí",
		Customer: "Khách hàng",
		Edit: "Chỉnh sửa",
		Delete: "Xoá",
		Search: "Tìm kiếm",
		Create: "Tạo mới {object}",
		Update: "Chỉnh sửa  {object}",
		FullName: "Họ và tên",
		Nickname: "Tên thường gọi",
		Phone: "Số điện thoại",
		City: "Tỉnh/ thành phố",
		District: "Quận/ Huyện",
		Ward: "Phường/ Xã",
		Assigned: "Người phụ trách",
		TotalPool: "Tổng số ao",
		Save: "Lưu",
		Input: "Nhập",
		Actions: {
			Submit: "Lưu",
			Send: "Gửi",
			SaveAndRecreate: "Lưu và Tạo mới",
			Save: "Lưu",
			Preview: "Xem",
			Close: "Đóng",
			Confirm: "Xác nhận",
			Input: "Nhập",
			Choose: "Chọn",
			ViewDetail: "Xem chi tiết",
			Add: "Thêm",
			Create: "Tạo mới",
			AddNew: "Tạo mới",
			Edit: "Chỉnh sửa",
			Delete: "Xóa",
			Search: "Tìm kiếm",
			Agree: "Đồng ý",
			Reject: "Từ chối",
			Approve: "Duyệt",
			Cancel: "Huỷ",
			Accept: "Chấp nhận",
			Back: "Quay Lại",
			Next: "Tiếp theo",
			LoadMore: "Tải thêm",
			Reset: "Đặt lại",
			Apply: "Áp dụng",
			Download: "Tải về",
			Recreate: "Tạo lại",
			Statistical: "Thống kê",
			SaveChanges: "Lưu thay đổi",
			Complete: "Hoàn thành",
			Reminder: "Nhắc nhở",
			No: "Không",
			Yes: "Có",
			SettingReminder: "Thiết lập nhắc nhở",
			Duplicate: "Tạo bản sao"
		},
		Notify: {
			Notification: "Thông báo",
			ErrorTitle: "Đã có lỗi xảy ra",
			NoDataAvailable: "Không có dữ liệu",
			HandleSuccessful: "Xử lý thành công",
			DeleteConfirm: "Bạn có chắc muốn xóa?",
			DeleteConfirmWithName: "Bạn có chắc muốn xóa {name}?",
			NoMatchingOptions: "Không tìm thấy lựa chọn phù hợp",
			LimitFileSizeWarning: "Tệp tin {fileName} có kích thước không hợp lệ.<br/>Kích thước tệp tối đa được hỗ trợ là {fileSize} {unit}.",
			LeaveConfirm: "Những thay đổi dữ liệu sẽ không được lưu. Bạn có chắc muốn thoát?",
			ChangeConfirm: "Những thay đổi dữ liệu sẽ không được lưu. Bạn có chắc muốn thay đổi?",
			DefaultServerError: "Đã có lỗi xảy ra, vui lòng thử lại hoặc thông báo với đội ngũ phát triển.",
			DownloadAppWarning: "Để có trải nghiệm tốt nhất trên thiết bị di động, quý khách vui lòng tải ứng dụng CBS để tiếp tục sử dụng!",
			SwitchConfirm: "Những thay đổi dữ liệu sẽ không được lưu. Bạn có chắc muốn chuyển?",
			AreYouSure: "Bạn có chắc muốn {action}?"
		},
		Street: "Số nhà, tên đường",
		DetailCustomer: "Chi tiết khách hàng",
		Address: "Địa chỉ",
		TechnicalDepartment: "Phòng kỹ thuật",
		Maps: "Bản đồ",
		UpdateSuccessful: "Cập nhật thành công",
		CreateSuccessful: "Tạo mới thành công",
		User: "Nhân viên",
		DetailUser: "Chi tiết nhân viên"
	},
	vi: {
		Customer: "Khách hàng",
		Edit: "Chỉnh sửa",
		Delete: "Xoá",
		Search: "Tìm kiếm",
		Create: "Tạo mới {object}",
		Update: "Chỉnh sửa  {object}",
		FullName: "Họ và tên",
		Nickname: "Tên thường gọi",
		Phone: "Số điện thoại",
		City: "Tỉnh/ thành phố",
		District: "Quận/ Huyện",
		Ward: "Phường/ Xã",
		Assigned: "Người phụ trách",
		TotalPool: "Tổng số ao",
		Save: "Lưu",
		Input: "Nhập",
		Actions: {
			Submit: "Lưu",
			Send: "Gửi",
			SaveAndRecreate: "Lưu và Tạo mới",
			Save: "Lưu",
			Preview: "Xem",
			Close: "Đóng",
			Confirm: "Xác nhận",
			Input: "Nhập",
			Choose: "Chọn",
			ViewDetail: "Xem chi tiết",
			Add: "Thêm",
			Create: "Tạo mới",
			AddNew: "Tạo mới",
			Edit: "Chỉnh sửa",
			Delete: "Xóa",
			Search: "Tìm kiếm",
			Agree: "Đồng ý",
			Reject: "Từ chối",
			Approve: "Duyệt",
			Cancel: "Huỷ",
			Accept: "Chấp nhận",
			Back: "Quay Lại",
			Next: "Tiếp theo",
			LoadMore: "Tải thêm",
			Reset: "Đặt lại",
			Apply: "Áp dụng",
			Download: "Tải về",
			Recreate: "Tạo lại",
			Statistical: "Thống kê",
			SaveChanges: "Lưu thay đổi",
			Complete: "Hoàn thành",
			Reminder: "Nhắc nhở",
			No: "Không",
			Yes: "Có",
			SettingReminder: "Thiết lập nhắc nhở",
			Duplicate: "Tạo bản sao"
		},
		Notify: {
			Notification: "Thông báo",
			ErrorTitle: "Đã có lỗi xảy ra",
			NoDataAvailable: "Không có dữ liệu",
			HandleSuccessful: "Xử lý thành công",
			DeleteConfirm: "Bạn có chắc muốn xóa?",
			DeleteConfirmWithName: "Bạn có chắc muốn xóa {name}?",
			NoMatchingOptions: "Không tìm thấy lựa chọn phù hợp",
			LimitFileSizeWarning: "Tệp tin {fileName} có kích thước không hợp lệ.<br/>Kích thước tệp tối đa được hỗ trợ là {fileSize} {unit}.",
			LeaveConfirm: "Những thay đổi dữ liệu sẽ không được lưu. Bạn có chắc muốn thoát?",
			ChangeConfirm: "Những thay đổi dữ liệu sẽ không được lưu. Bạn có chắc muốn thay đổi?",
			DefaultServerError: "Đã có lỗi xảy ra, vui lòng thử lại hoặc thông báo với đội ngũ phát triển.",
			DownloadAppWarning: "Để có trải nghiệm tốt nhất trên thiết bị di động, quý khách vui lòng tải ứng dụng CBS để tiếp tục sử dụng!",
			SwitchConfirm: "Những thay đổi dữ liệu sẽ không được lưu. Bạn có chắc muốn chuyển?",
			AreYouSure: "Bạn có chắc muốn {action}?"
		},
		Street: "Số nhà, tên đường:",
		DetailCustomer: "Chi tiết khách hàng",
		Address: "Địa chỉ",
		TechnicalDepartment: "Phòng kỹ thuật",
		Maps: "Bản đồ",
		UpdateSuccessful: "Cập nhật thành công",
		CreateSuccessful: "Tạo mới thành công",
		User: "Nhân viên",
		DetailUser: "Chi tiết nhân viên"
	}
};
